<template>
    <div class="contact-details">

        <h4>Head Office</h4>

        <p v-if="headOffice.address" v-html="headOffice.address"></p>

        <p v-if="headOffice.phone || headOffice.fax || headOffice.email">
            <span v-if="headOffice.phone">Telephone: <a :href="buildPhoneUrl(headOffice.phone)" v-html="headOffice.phone"></a></span>
            <br>
            <span v-if="headOffice.fax">Fax: {{ headOffice.fax }}</span>
            <br>
            <span v-if="headOffice.email">Email: <a :href="buildEmailUrl(headOffice.email)" v-html="headOffice.email"></a></span>
        </p>

        <h4>Dealing and Registration</h4>

        <p v-if="dealingReg.name || dealingReg.address">
            <span v-if="dealingReg.name" v-html="dealingReg.name"></span>
            <br>
            <span v-if="dealingReg.address" v-html="dealingReg.address"></span>
        </p>

        <p v-if="dealingReg.phone || dealingReg.fax || dealingReg.email">
            <span v-if="dealingReg.phone">Telephone: <a :href="buildPhoneUrl(dealingReg.phone)" v-html="dealingReg.phone"></a></span>
            <br>
            <span v-if="dealingReg.fax">Fax: {{ dealingReg.fax }}</span>
            <br>
            <span v-if="dealingReg.email">Email: <a :href="buildEmailUrl(dealingReg.email)" v-html="dealingReg.email"></a></span>
        </p>

        <h4>Supporting Your Needs</h4>

        <p>
            When events in life and personal circumstances affect how you manage your finances, we're here
            to help. Please contact our specialist Client Services Team for more information on how we can
            support you on 0121 236 2380 during office hours.
        </p>

	<h4>Consumer Feedback</h4>

        <p>
            We would appreciate your feedback. Please provide your comments using this link:
            <a href="https://investors.margetts.com/consumer-feedback" target="_blank">Consumer Feedback</a>
        </p>

        <h4>Complaints</h4>

        <p>
            If you wish to complain about any aspect of the service you have received, or any aspect of this site, please
            contact us by phone, email or by letter:
        </p>

        <p v-if="complaints.name || complaints.address">
            <span v-if="complaints.name" v-html="complaints.name"></span>
            <br>
            <span v-if="complaints.address" v-html="complaints.address"></span>
        </p>

        <p v-if="complaints.phone || complaints.email">
            <span v-if="complaints.phone">Telephone: <a :href="buildPhoneUrl(complaints.phone)" v-html="complaints.phone"></a></span>
            <br>
            <span v-if="complaints.email">Email: <a :href="buildEmailUrl(complaints.email)" v-html="complaints.email"></a></span>
        </p>

        <p v-if="complaints.ombudsman">
            We endeavour to respond to all complaints within 3 working days, in the event you are not satisfied with our
            response, you may have the right to refer the complaint to the Financial Ombudsman Service at
            <a :href="complaints.ombudsman.url" :target="buildLinkTarget(complaints.ombudsman.url)" v-html="complaints.ombudsman.url"></a>
            or telephone on <a :href="buildPhoneUrl(complaints.ombudsman.phone)" v-html="complaints.ombudsman.phone"></a>
        </p>

        <p>
            All incoming and outgoing telephone calls to the Margetts offices may be recorded for the purpose of
            monitoring, compliance and training.
        </p>

    </div>
</template>

<script>

import ApiWidget from './ApiWidget';

export default {
    extends: ApiWidget,
    data() {
        return {
            headOffice: {},
            dealingReg: {},
            complaints: {}
        }
    },

    methods: {

        async update(data) {
            if (data.display === 'none') {
                return this.$el.closest('.page-widget').hidden = true;
            }

            this.headOffice = data.head_office;
            this.dealingReg = data.dealing_reg;
            this.complaints = data.complaints;
        },

        buildEmailUrl(email) {
            return 'mailto:' + email;
        },

        buildPhoneUrl(phone) {
            return 'tel:' + phone;
        },

        buildLinkTarget(linkNewTab) {
            return linkNewTab.value === 'on' ? '_blank' : null;
        }

    }
}
</script>
